import { Component, OnInit } from '@angular/core';
import { DocumentService } from 'src/app/services/document.service'

@Component({
  selector: 'app-download-form',
  templateUrl: './download-form.component.html',
  styleUrls: ['./download-form.component.scss']
})
export class DownloadFormComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  docList: any
  flag: any
  countTopic: any = 0
  countDetail: any = 0
  constructor(private _docService: DocumentService) { }

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")
    localStorage.setItem('countTopic', this.countTopic);
    localStorage.setItem('countDetail', this.countTopic);
    this._docService.getDocumentList().subscribe(response => {
      // console.log(response);
      this.docList = response
    })
  }

}
